import { isObjectLike as _isObjectLike } from 'lodash-es';

export function isObjectLike(value: unknown): value is object {
	return _isObjectLike(value);
}
